module.exports = __webpack_public_path__ + "media/images/starworksPlus-logo-3734752e18695e227a65f97a3c57f401.svg";